import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { AddOrderInstructionLineModalLineFragmentDoc } from './AddOrderInstructionModalLine.generated'
import { AdvancedRequisitionLineModalLineFragmentDoc } from './AdvancedRequisitionLineModalLine.generated'
import { QuotesModalLineFragmentDoc } from './QuotesModalLine.generated'
import * as Types from './purchasePlus_graphql'

export const RequisitionLineExtraLineItemLineFragmentDoc = gql`
  fragment RequisitionLineExtraLineItemLine on RequisitionLine {
    id
    uuid
    ...AdvancedRequisitionLineModalLine
    ...QuotesModalLine
    ...AddOrderInstructionLineModalLine
    cataloguedProduct {
      id
      outOfStock
    }
    unitPrice
    taxPercentage
    unitTax
    product {
      id
      availableQuotes {
        taxPercentage
        unitPrice
      }
    }
  }
  ${AdvancedRequisitionLineModalLineFragmentDoc}
  ${QuotesModalLineFragmentDoc}
  ${AddOrderInstructionLineModalLineFragmentDoc}
` as unknown as DocumentNode<Types.RequisitionLineExtraLineItemLineFragment, unknown>
